export default __webpack_public_path__ + "static/media/weight.c1a03c48.png";